import { Base } from '@studiometa/js-toolkit';
import { ScrollAnimationParent } from '@studiometa/ui';

/**
 * Composant vide utilisé en dessous de 1024px
 */
class DisabledScrollAnimation extends Base {
  static config = {
    name: 'DisabledScrollAnimation',
  };
}

/**
 * Wrapper conditionnel pour ScrollAnimationParent
 * Désactivé en dessous de 1024px
 *
 * Retourne un composant vide si la largeur d'écran est < 1024px,
 * sinon retourne ScrollAnimationParent
 */
const ConditionalScrollAnimationParent =
  window.innerWidth >= 1024 ? ScrollAnimationParent : DisabledScrollAnimation;

export default ConditionalScrollAnimationParent;
